import { useEffect } from "react";
import { trackEvent } from "@hopper-b2b/api";
import { useI18nContext } from "@hopper-b2b/i18n";
import { WalletTrackingEvents } from "@hopper-b2b/types";
import { ActionLink, MobilePopoverCard } from "@hopper-b2b/ui";
import Close from "../../assets/client/close.svg?react";
import OfferList from "../OfferList";
import style from "./styles.module.scss";

interface IOfferTakeoverProps {
  open: boolean;
  onClose: () => void;
  offers: any; // TODO: Update type
}

const OfferTakeover = ({ open, onClose, offers }: IOfferTakeoverProps) => {
  const { t } = useI18nContext();

  useEffect(() => {
    if (open) {
      trackEvent({
        eventName: WalletTrackingEvents.viewed_wallet_offers,
        properties: {},
      });
    }
  }, [open]);

  return (
    <MobilePopoverCard
      open={open}
      onClose={onClose}
      paperClassName={style.homeOfferTakeoverModalContent}
      className={style.homeOfferTakeoverModal}
      topRightButton={
        <ActionLink
          onClick={onClose}
          content={<Close className="close-icon" />}
        />
      }
    >
      <div className={style.homeOfferTakeover}>
        <div className="home-offer-takeover-photo"></div>
        <div className="home-offer-takeover-header">
          <h2 className="home-offer-takeover-title">{t("offers.title")}</h2>
          <p className="home-offer-takeover-subtitle">{t("offers.subtitle")}</p>
        </div>
        <OfferList modal offers={offers} />
      </div>
    </MobilePopoverCard>
  );
};

export default OfferTakeover;
